import data from 'shared/utils/data'

export default {
  ...data
}
